import {initReactI18next, useTranslation} from "react-i18next"
import React, {useState} from "react"
import ApiService from "@bodeboca/api"
import InsightsUtils from "@bodeboca/algolia/utils/insights"
import {use} from "i18next"
import CommonUtils from "@bodeboca/utils"

type Props = {
    productId: number;
    title: string;
    sendEvent: any;
    queryID: any;
    hit: any;
    buttonClass: string;
    productUrl?: string
};

// Veuve Clicquot Arrow (bb_vc_arrow): element of the personaliser on its
// product page, and global where the personaliser leaves the destination.
const VC_ARROW_PERSONALIZER_ID = 'vc-arrow-personalizer'
const VC_ARROW_DESTINATION = 'bbVcArrowDestination'


use(initReactI18next)
  .init(CommonUtils.i18NConfig())
  .then(() => {
    // I18N Loaded.
  })

const AddToCart = ({productId, title, sendEvent = undefined, queryID = undefined, hit = undefined, buttonClass = '', productUrl = undefined}: Props) => {
  const [amount, setAmount] = useState(1)
  const {t} = useTranslation()

  // The Veuve Clicquot Arrow is only added to the cart with a destination,
  // chosen in the personaliser of its product page. Elsewhere it links there.
  const vcArrowId = drupalSettings['bb_vc_arrow']?.product_id
  const isVcArrow = vcArrowId !== undefined && Number(productId) === Number(vcArrowId)
  if (isVcArrow && document.getElementById(VC_ARROW_PERSONALIZER_ID) === null) {
    const personalise = () => {
      if (hit !== undefined) {
        InsightsUtils.setQueryId(hit['product_id'], hit['__queryID'])
      }
    }

    return (<div className="add-to-cart vc-arrow-personalise">
      <a
        className={"bb-button radiocanadabigbutton " + buttonClass}
        href={(productUrl ?? '') + '#' + VC_ARROW_PERSONALIZER_ID}
        onClick={personalise}>{t("Personalise")}</a>
    </div>)
  }

  function increment() {
    setAmount(amount + 1)
  }

  function decrement() {
    if (amount >= 2) setAmount(amount - 1)
  }

  function addToCart() {

    let custom = undefined
    if (isVcArrow) {
      const destination = window[VC_ARROW_DESTINATION]
      if (!destination) {
        CommonUtils.showBbAjaxMessage(t('Choose the destination of your case before adding it to the cart.'), 'error')
        document.getElementById(VC_ARROW_PERSONALIZER_ID)?.scrollIntoView({behavior: 'smooth', block: 'start'})
        return
      }
      custom = {
        custom_city: destination.city,
        custom_km: destination.km,
        // The customer is told (notice from D6) if this destination replaces
        // the one of the units already in the cart.
        custom_city_replace: 1,
      }
    }

    InsightsUtils.getQueryId()
    ApiService.addToCart(productId, amount, title , queryID ?? undefined, custom)

    if(sendEvent !== undefined && hit !== undefined) {
      sendEvent("conversion", hit, "Added to cart after search (list)", {
        eventSubtype: "addToCart",
      })
    }
    else {
      if (queryID !== undefined) {
        InsightsUtils.addedToCartObjectIDsAfterSearch(productId + '')
      } else {
        InsightsUtils.addedToCartObjectIDs(productId + '')
      }

    }
  }


  return (<div className="add-to-cart">
    <div className="quantity-whole-formato-wrapper">
      <div className="quantity-whole-wrapper">
        <input
          className="minus"
          defaultValue="-"
          type="button"
          onClick={decrement}/>
        <div className="form-item form-item-textfield">
          <div className="hidden text-entered js-processed">Quantity
          </div>
          <input
            className="form-text quantity"
            data-nid={productId}
            maxLength={3}
            size={60}
            type="text"
            value={amount}
            onChange={(e) => {
              setAmount(e.target.value)
            }}/>
        </div>
        <input
          className="plus"
          defaultValue="+"
          type="button"
          onClick={increment}/>
      </div>
    </div>
    <div className="submit-wrapper">
      <img
        alt="Carrito de la compra"
        height="17"
        src="/themes/custom/bodeboca/fonts/svg/cesta.svg"
        width="26"/>
      <input
        className={"node-add-to-cart ajax-cart-submit-form-button bb-button radiocanadabigbutton form-submit " + buttonClass}
        type="button"
        value={t("Add to cart")}
        onClick={addToCart}/>
    </div>
  </div>)
}
export default AddToCart
